import { http } from './config'

const permissoesNavegacao = new Map()

function limparCachePermissoes() {
    permissoesNavegacao.clear()
}

export default {
    limparCachePermissoes,
    getGruposPermissao: (data = null, params = null) => {
        params = params ? "?" + params : "/"
        return http.get('grupopermissao/list' + params, data)
    },
    getById: (id) => {
        return http.get('grupopermissao/' + id)
    },
    getMenus: (grupo_id) => {
        return http.get('grupopermissao/' + grupo_id + '/menus')
    },
    getUsuarios: (grupo_id) => {
        return http.get('grupopermissao/' + grupo_id + '/usuarios')
    },
    saveGrupoPermissao: (data) => {
        return http.post('grupopermissao/save', data).then(response => {
            limparCachePermissoes()
            return response
        })
    },
    deleteGrupoPermissao: (id) => {
        return http.delete('grupopermissao/' + id).then(response => {
            limparCachePermissoes()
            return response
        })
    },
    getPermissao: (url, config = {}) => {
        if (!permissoesNavegacao.has(url)) {
            const request = http.get('grupopermissao/verificapermissao?url=' + url, { silent: true, ...config })
            permissoesNavegacao.set(url, request)
            request.catch(() => {
                if (permissoesNavegacao.get(url) === request) {
                    permissoesNavegacao.delete(url)
                }
            })
        }
        return permissoesNavegacao.get(url)
    },
    gerenciaPermissao: (url, config = {}) => {
        return http.get('grupopermissao/gerenciapermissao?url=' + url, { silent: true, ...config })
    },
    getGruposPermissaoDropbox: (data = null, params = null) => {
        params = params ? "?" + params : "/"
        return http.get('grupopermissao/listar-dropbox' + params, data)
    },
    getTodasPermissoes: () => {
        return http.get('grupopermissao/get-todas-permissoes', { silent: true })
    },
}